import React from 'react';
import { DeviceMobile, Monitor } from '@phosphor-icons/react';
import type { Format } from '../../types/snak';
interface FormatToggleProps {
  value: Format;
  onChange: (format: Format) => void;
  className?: string;
}
export function FormatToggle({
  value,
  onChange,
  className = ''
}: FormatToggleProps) {
  return <div role="group" aria-label="Presentation format" className={['inline-flex items-center gap-1 rounded-full border border-[rgba(1,51,43,0.14)] bg-white/70 p-1', className].join(' ')} data-id="element-161" data-mp="30ae50hr5pg03">
      <Option active={value === 'mobile'} onClick={() => onChange('mobile')} label="Phone" title="Show every layer in the phone" data-id="element-162" data-mp="3svw6ndm1pvpb">
        <DeviceMobile size={14} aria-hidden="true" data-id="element-163" data-mp="3iz1b93l2kbf9" />
      </Option>
      <Option active={value === 'desktop'} onClick={() => onChange('desktop')} label="Desktop" title="Show the layers at full desktop width" data-id="element-164" data-mp="2cka3qh1fxsc9">
        <Monitor size={14} aria-hidden="true" data-id="element-165" data-mp="1wpg4nx35ktxd" />
      </Option>
    </div>;
}
function Option({
  children,
  label,
  title,
  active,
  onClick
}: {
  children: React.ReactNode;
  label: string;
  title: string;
  active: boolean;
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} title={title} aria-pressed={active} className={['inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-body text-[10px] uppercase tracking-[0.16em] transition-colors', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary', active ? 'bg-background text-white' : 'text-[rgba(1,51,43,0.5)] hover:text-background'].join(' ')} data-id="element-166" data-mp="1mr0f3yjrxspz">
      {children}
      <span className="hidden sm:inline" data-id="element-167" data-mp="1903nob1l3hki">{label}</span>
    </button>;
}